import { initializeDisneyRewardsTrackingCodes } from './index';

(() => {
    document.addEventListener('DOMContentLoaded', () => {
        initializeDisneyRewardsTrackingCodes();
    });
})();
